import React from 'react'
import PropTypes from 'prop-types'

import Text from '../../common/Text'
import { rem } from 'polished'

function ErrorText({ children, id, show, ...props }) {
  return (
    <Text
      id={id}
      role={show ? 'alert' : undefined}
      aria-live="polite"
      css={{
        opacity: show ? 1 : 0,
        marginTop: rem(5),
        height: rem(20),
        pointerEvents: 'none',
        zIndex: 0,
      }}
      size="xs"
      {...props}
    >
      {children}
    </Text>
  )
}

ErrorText.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  show: PropTypes.bool,
}

export default ErrorText
